define('v3/Common/Services/pupilSortService',['v3/FromV2/cultureService', 'v3/FromV2/localStorageV3Service'], function (cultureService, cookieService) {
	var name = 'pupil_sorting_';

	function getKey (classId) {
		return name + classId;
	}

	return {
		getSortField: function (classId) {
			var result = localStorage.getItem(getKey(classId));
			if (!result) {
				result = cookieService.getPupilSortingLegacyLocalStorage(classId);
				if (result) {
					this.setSortField(classId, result);
				} else {
					if (cultureService.isCurrentCountryEs()) {
						return this.getSortValueLastName();
					}
					return this.getSortValueFirstName();
				}
			}

			return result;
		},
		setSortField: function (classId, fieldName) {
			localStorage.setItem(getKey(classId), fieldName);
		},
		getSortValueFirstName: function () {
			return 'firstNameForSorting';
		},
		getSortValueLastName: function () {
			return 'lastNameForSorting';
		}
	};
});

